import { render, staticRenderFns } from "./RuleGroupTable.vue?vue&type=template&id=2b088e64"
import script from "./RuleGroupTable.vue?vue&type=script&lang=js"
export * from "./RuleGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports